import React from 'react';
import './LeftTwoRightOne.less';

interface LeftTwoRightOneState {

}

interface LeftTwoRightOnePropType {
  prefixCls?: string;
  floorId: any;
  floorTemplate: any[];
  onFloorClick: Function;
}

class LeftTwoRightOne extends React.Component<LeftTwoRightOnePropType, LeftTwoRightOneState> {
  static defaultProps = {
    prefixCls: 'leftTwoRightOne',
  };
  render() {
    const { prefixCls, floorId, floorTemplate, onFloorClick } = this.props;
    return (
      <div className={prefixCls}>
        <div className={`${prefixCls}imgBox`}>
          <div className={`${prefixCls}leftBox`}>
            <div className={`${prefixCls}leftTopBox`} onClick={() => {
              onFloorClick && onFloorClick(floorId, floorTemplate[0].moduleName, floorTemplate[0].moduleUrlType, floorTemplate[0].moduleUrl)
            }}>
              <img src={floorTemplate[0].moduleImgUrl} alt="" />
            </div>
            <div className={`${prefixCls}leftBottomBox`} onClick={() => {
              onFloorClick && onFloorClick(floorId, floorTemplate[1].moduleName, floorTemplate[1].moduleUrlType, floorTemplate[1].moduleUrl)
            }}>
              <img src={floorTemplate[1].moduleImgUrl} alt="" />
            </div>
          </div>
          <div className={`${prefixCls}rightBox`} onClick={() => {
            onFloorClick && onFloorClick(floorId, floorTemplate[2].moduleName, floorTemplate[2].moduleUrlType, floorTemplate[2].moduleUrl)
          }}>
            <img src={floorTemplate[2].moduleImgUrl} alt="" />
          </div>
        </div>
      </div>
    );
  }
}
export default LeftTwoRightOne;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/floorModule/leftTwoRightOne/LeftTwoRightOne.tsx